
import Vue from "vue";
import notifications from "@/lib/notifications";
import { RoleListResource } from "../../models/api/system/roles";
import { GroupResource, SaveGroupRequest } from "../../models/api/system/groups";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import Component from "vue-class-component";

const systemModuleState = getModule(SystemModule);

@Component
export default class GroupEdit extends Vue {
  loading: boolean = false;
  loadingPage: boolean = false;
  roles: RoleListResource[] = [];
  groupDetail: GroupResource = { id: null, name: null, role: { id: null, name: null } };

  async created() {
    this.loadingPage = true;
    this.roles = await systemModuleState.getRoles();
    if (this.$route.params.id) {
      this.groupDetail = await systemModuleState.getGroupDetail(+this.$route.params.id);
    }
    this.loadingPage = false;
  }

  get isNew() {
    return this.groupDetail.id === null;
  }
  rowClicked(item) {
    item.allowed = !item.allowed;
  }

  async save() {
    this.loading = true;
    let request = new SaveGroupRequest();
    request.id = this.groupDetail.id;
    request.name = this.groupDetail.name;
    request.roleId = this.groupDetail.role.id;
    const response = await systemModuleState.saveGroup(request);
    notifications.success("Group saved", "Group changes saved");
    if (this.isNew) this.$router.push(`/admin/groups/${response.id}`);
    this.loading = false;
  }
}
